import React from 'react';

/* [height:341, viewBox = '0 0 419 221']   for facebook event video default image */
const CourseSvg = () => (
  <svg viewBox="0 0 419 341" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 3.99999C0 1.79085 1.79086 0 4 0H415C417.209 0 419 1.79086 419 4V336.097C419 338.307 417.209 340.097 415 340.097H3.99999C1.79085 340.097 0 338.307 0 336.097V3.99999Z"
      fill="white"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="419"
      height="341"
    >
      <path
        d="M0 3.99999C0 1.79085 1.79086 0 4 0H415C417.209 0 419 1.79086 419 4V336.097C419 338.307 417.209 340.097 415 340.097H3.99999C1.79085 340.097 0 338.307 0 336.097V3.99999Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 -0.762695L419 -0.000145078V340.097H0V-0.762695Z"
        fill="#F6F6FB"
      />
      <mask
        id="mask1"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="419"
        height="342"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 -0.762695L419 -0.000145078V340.097H0V-0.762695Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1)" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M276.261 120.72L322.506 122.853C329.849 123.173 335.399 128.611 335.063 135.276L327.271 275.669C326.879 282.387 320.769 287.293 313.369 286.973L128.333 278.601C120.934 278.228 115.44 272.789 115.777 266.071L117.122 241.65L108.714 242.29C102.155 242.77 96.4378 238.558 95.8772 232.533L83.9936 106.803C83.4892 100.831 88.2538 95.766 94.8683 95.2328L260.734 82.276C267.349 81.7961 273.01 86.0084 273.571 92.0336L276.261 120.72ZM119.588 197.555L123.568 125.679C123.905 119.014 130.014 114.108 137.414 114.322L260.173 119.92L258.66 103.498C258.66 103.435 258.602 103.391 258.554 103.354C258.521 103.328 258.492 103.306 258.492 103.284C258.492 103.231 258.45 103.204 258.408 103.178C258.366 103.151 258.324 103.124 258.324 103.071C257.875 100.458 255.353 98.6454 252.438 98.8587L106.135 110.269C103.22 110.483 101.314 112.615 100.754 115.281V115.548V115.815L109.779 210.725L119.588 197.555ZM310.791 251.994L263.257 198.941L242.292 217.23L203.502 174.147L134.723 243.836L140.553 137.676V137.462C141.113 134.583 144.028 132.504 147.223 132.664L310.455 140.128C313.706 140.288 316.228 142.634 316.284 145.567C316.284 145.62 316.326 145.66 316.368 145.7C316.41 145.74 316.452 145.78 316.452 145.834L310.791 251.994ZM299.188 167.535C299.188 176.92 291.116 184.598 281.25 184.598C271.328 184.598 263.313 176.973 263.313 167.535C263.313 158.098 271.384 150.473 281.25 150.473C291.172 150.473 299.188 158.151 299.188 167.535Z"
      fill="#E3DAE6"
    />
  </svg>
);

export default CourseSvg;
